import { bscTokens } from '@pancakeswap/tokens'
import { FeeAmount } from '@pancakeswap/v3-sdk'
import { FarmConfigV3 } from '../src'
import { defineFarmV3Configs } from '../src/defineFarmV3Configs'

const v3TopFixedFarms: FarmConfigV3[] = [
    {
      pid: 1,
      lpAddress: '0x173b37ae4420e0d08a549e854b69cb3f5ffbba24',
      token0: bscTokens.wbnb,
      token1: bscTokens.usdc,
      feeAmount: FeeAmount.MEDIUM,
    }
]

export const farmsV3 = defineFarmV3Configs([
  ...v3TopFixedFarms,

])

export default farmsV3
